var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import classNames from 'classnames';
import CollapsibleItem from 'components/v2/list/CollapsibleItem';
import ChevronRightIcon from 'components/v2/icons/ChevronRightIcon';
import ChevronDownIcon from 'components/v2/icons/ChevronDownIcon';
import Badge from 'components/v2/Badge';
import Table from 'components/v2/Table';
import { useTranslation } from 'react-i18next';
import { unescapeSpecialChars } from 'helpers/helper_functions';
const WarehouseSummary = ({ data = {}, defaultOpen }) => {
    var _a;
    const { t } = useTranslation();
    const renderViewMore = (open) => {
        return (React.createElement("div", { className: "flex-shrink-0 flex-grow-0" },
            React.createElement("div", { className: classNames('flex-grow-0 flex-shrink-0 cursor-pointer') },
                !open && React.createElement(ChevronRightIcon, { className: "w-5 h-5" }),
                open && React.createElement(ChevronDownIcon, { className: "w-5 h-5" }))));
    };
    const renderHeading = (open) => {
        return (React.createElement("div", { className: "flex items-center space-x-2 relative" },
            renderViewMore(open),
            React.createElement("h3", { className: "flex-1 font-bold" }, data === null || data === void 0 ? void 0 : data.address)));
    };
    const renderTitle = (name) => {
        return (open) => {
            return (React.createElement("div", { className: "flex items-center space-x-2 relative" },
                renderViewMore(open),
                React.createElement("h3", { className: "flex-1 font-semibold text-gray-600" }, unescapeSpecialChars(name))));
        };
    };
    const renderAssociations = () => {
        var _a;
        return (_a = data === null || data === void 0 ? void 0 : data.shippers) === null || _a === void 0 ? void 0 : _a.map((_a) => {
            var { warehouseUsers } = _a, shipper = __rest(_a, ["warehouseUsers"]);
            return (React.createElement(CollapsibleItem, { className: "px-6 mt-4", renderTitle: renderTitle(shipper.company_name || `${shipper.first_name} ${shipper.last_name}`), key: shipper._id, position: "left", hideIcon: true },
                React.createElement("div", { "data-testid": "warehouse-summary-item", className: "table-wrapper mt-4" },
                    React.createElement(Table, { headers: [
                            { field: 'name', label: t('WAREHOUSE_USER') },
                            { field: 'status', label: t('STATUS') },
                        ], columns: [
                            {
                                field: 'name',
                                render: (value, cell) => value || `${cell.first_name} ${cell.last_name}`,
                            },
                            {
                                field: 'status',
                                render: (status) => (React.createElement(Badge, { className: "-ml-1", color: status ? 'green' : 'gray' }, status ? t('ACTIVE') : t('INACTIVE'))),
                            },
                        ], data: warehouseUsers, colWidths: [60, 40] }))));
        });
    };
    return (React.createElement(CollapsibleItem, { renderTitle: renderHeading, className: "flex-1", hideIcon: true, defaultOpen: defaultOpen }, ((_a = data === null || data === void 0 ? void 0 : data.shippers) === null || _a === void 0 ? void 0 : _a.length) ? (renderAssociations()) : (React.createElement("p", { className: "ml-8 mt-2" }, t('NO_SHIPPER_ASSOCIATION')))));
};
export default WarehouseSummary;
